import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const MODULOS_CONST = 'modulos';
export const modulos_api = `${baseUrl}/sistema/${MODULOS_CONST}`;

export const allModulosService = async (params) => {
  const res = await axios.get(modulos_api, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveModulosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${modulos_api}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(modulos_api, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneModulosService = async (id) => {
  const res = await axios.get(`${modulos_api}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteModulosService = async (id) => {
  const res = await axios.delete(`${modulos_api}/${id}`, {
    headers: token({}),
  });
  return res;
};
